export default {
  init() {
    // JavaScript to be fired on the home page
  },
  finalize() {
    $('.main-header').attr('style', '');
  },
};



// WEBPACK FOOTER //
// ./scripts/routes/home.js